// extracted by mini-css-extract-plugin
module.exports = {"button":"_5b10bb2305--button--OG_GQ"};